<template>
    <v-layout row justify-center>
        <v-dialog :value="show" persistent max-width="840">
            <v-card>
                <v-card-title class="primary headline white--text">
                    <v-layout>
                        <v-flex xs10 sm9 pt-2>
                            <span>{{ $t('profileAdvantage.title') }}</span>
                        </v-flex>
                        <v-flex xs2 sm3 text-right>
                            <v-btn icon @click="$emit('close')">
                                <v-icon large color="white">
                                    close
                                </v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <p class="title">
                        {{ $t('profileAdvantage.subtitle') }}
                    </p>
                    <v-list>
                        <v-list-tile class="pb-2">
                            <v-list-item-title class="advantage-list">
                                <v-layout row wrap>
                                    <v-flex xs2 sm1>
                                        <v-icon class="mr-6">
                                            fa-check
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs10 sm11>
                                        {{ $t('profileAdvantage.advantage1') }}
                                    </v-flex>
                                </v-layout>
                            </v-list-item-title>
                        </v-list-tile>
                        <v-list-tile class="pb-2">
                            <v-list-item-title class="advantage-list">
                                <v-layout row wrap>
                                    <v-flex xs2 sm1>
                                        <v-icon class="mr-6">
                                            fa-check
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs10 sm11>
                                        {{ $t('profileAdvantage.advantage2') }}
                                    </v-flex>
                                </v-layout>
                            </v-list-item-title>
                        </v-list-tile>
                        <v-list-tile class="pb-2">
                            <v-list-item-title class="advantage-list">
                                <v-layout row wrap>
                                    <v-flex xs2 sm1>
                                        <v-icon class="mr-6">
                                            fa-check
                                        </v-icon>
                                    </v-flex>
                                    <v-flex xs10 sm11>
                                        {{ $t('profileAdvantage.advantage3') }}
                                    </v-flex>
                                </v-layout>
                            </v-list-item-title>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-card-actions :class="$vuetify.breakpoint.smAndDown ? 'mt-4' : ''">
                    <v-flex text-center>
                        <v-btn
                            color="primary"
                            @click="register">
                            {{ $t('profileAdvantage.actionBtn') }}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>

export default {
    name: 'advantage-profile-modal',
    props: {
        show: { type: Boolean, required: false, default: true },
    },
    methods: {
        /**
         * Set button state and emit the 'gotoCalendar' event
         */
        close() {
            this.$emit('close');
        },

        /**
         * Set button state and emit the 'selectedTimeSlot' event
         */
        register() {
            this.$emit('redirectToRegister');
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.advantage-list {
    white-space: normal;
    overflow: visible;
}
</style>
